export default __webpack_public_path__ + "static/media/b02.a070cd67.jpg";